<template>
    <v-container class="fill-height align-center justify-center">
        <v-card class="login-card">
            <v-card-text class="d-flex justify-center">
                <img :src="logoImage" height="38" alt="Corra">
            </v-card-text>
            <v-card-text>
                <v-form ref="form" v-model="valid">
                    <v-text-field
                            v-model="login"
                            label="Логин"
                            required
                    ></v-text-field>

                    <v-text-field
                            v-model="password"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="showPassword ? 'text' : 'password'"
                            label="Пароль"
                            required
                            @click:append="showPassword = !showPassword"
                    ></v-text-field>
                </v-form>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-btn :disabled="!valid" color="primary" outlined class="px-8 py-4 login-button" @click="doLogin">
                    Войти
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
    import logoImage from "@/assets/corra-logo-dark.svg";

    export default {
        data() {
            return {
                login: '',
                password: '',
                valid: false,
                showPassword: false,
                logoImage,
            }
        },
        watch: {
            login() {
                this.validate();
            },
            password() {
                this.validate();
            }
        },
        methods: {
            validate() {
                this.$refs.form.validate();
            },
            async doLogin() {
                await this.$store.dispatch('loginUser', {login: this.login, password: this.password});
                if (this.$store.getters.isLoggedIn) {
                    let nextRoute = null;
                    try {
                        nextRoute = (new URL(window.location.href)).searchParams.get('redirect');
                        if (!nextRoute) {
                            nextRoute = '/';
                        }
                    }
                    catch (e) {
                        nextRoute = '/';
                    }

                    return this.$router.push({path: nextRoute});
                }
            }
        }
    }
</script>

<style lang="scss">
    .login {
        &-button {
            height: 50px!important;
            width: 134px;
        }

        &-card {
            padding: 60px;
            border-radius: 14px!important;
            box-shadow: 0 0 12px rgba(0, 0, 0, 0.2)!important;

            .theme--light {
                &.v-label, &.v-icon {
                    color: rgba(0, 0, 0, 0.29);

                    &.primary--text {
                        color: #000000!important;
                        font-weight: 500;
                    }
                }

                &.v-text-field > .v-input__control > .v-input__slot:before {
                    border-color: rgba(0, 0, 0, 0.043) !important;
                }
            }
        }
    }
</style>